/**
 * Extracts field name from error string, e.g.
 * returns "postcode" from string "'postcode' not found".
 */
export const extractErrorFieldName = (msg: string): string[] => {
  const fieldNames = [
    'emailAddress',
    'firstname',
    'lastname',
    'postcode',
    'addressLine1',
    'addressLine2',
    'city',
    'county',
    'country',
  ]

  try {
    return fieldNames.filter((fieldName) => msg.includes(fieldName))
  } catch (error) {
    return []
  }
}

/**
 * Formats error string turning "'emailAddress' is already taken"
 * into "Email address is already taken".
 */
export const formatErrorMessage = (msg: string): string => {
  if (typeof msg !== 'string') return ''

  // strip single quotes and split camelCase
  const formattedMsg = msg
    .replace(/'/g, '')
    .replace(/([a-z])([A-Z]|[0-9])/g, '$1 $2')
    .replace(/firstname/, 'first name')
    .replace(/lastname/, 'last name')
    .toLowerCase()

  // Capitalize
  return formattedMsg.charAt(0).toUpperCase() + formattedMsg.slice(1)
}

/**
 * Builds error object for use in Vuelidate $externalResults
 * Return example:
 * {
 *   emailAddress: ['Email address is in use'],
 *   postcode: ['Postcode not found', 'Postcode not valid']
 * }
 */
export default (errors: string[]): { [key: string]: string[] } => {
  if (!Array.isArray(errors)) return {}

  const errorsObj: { [k: string]: any } = {}

  for (const error of errors) {
    let errorFieldNames = extractErrorFieldName(error)

    if (!errorFieldNames.length) {
      errorFieldNames = ['misc']
    }

    for (const errorFieldName of errorFieldNames) {
      if (errorFieldName) {
        if (errorFieldName in errorsObj) {
          errorsObj[errorFieldName].push(formatErrorMessage(error))
        } else {
          Object.assign(errorsObj, {
            [errorFieldName]: [formatErrorMessage(error)],
          })
        }
      }
    }
  }

  return errorsObj
}
